import { viewport } from '../../utils/viewport';

document.addEventListener('alpine:init', () => {
  Alpine.data('ecommerceTextLists', () => ({
    lists: [],

    init() {
      this.$nextTick(() => {
        this.$root.querySelectorAll('.ecommerce-text-lists__source > div').forEach((source) => {
          const children = [...source.children];

          if (children.length === 2) {
            const list = {
              title: children[0].textContent,
            };

            if (children[1].nodeName === 'OL') {
              const rows = children[1].textContent.trim().split('\n');
              const compare = rows.map((row) =>
                row
                  .split(/(.+): (.+)/)
                  .map((part) => part.trim())
                  .filter(Boolean)
              );
              const charts = rows.map((row) =>
                row
                  .split(/(.+)–(.+)/)
                  .map((part) => part.trim())
                  .filter(Boolean)
              );

              if (compare.every((p) => p.length === 2 && p[1].includes('|'))) {
                // Show compare list
                list.type = 'compare';
                list.items = compare.map((p) => ({
                  label: p[0],
                  values: p[1].split('|').map((pv) => pv.trim()),
                }));
              } else if (charts.every((p) => p.length === 2)) {
                // Show chart boxes
                list.type = 'charts';
                list.items = charts.map((p) => ({
                  type: p[1].endsWith('%') ? 'percent' : 'default',
                  label: p[0],
                  value: p[1],
                }));
              } else {
                // Simple box
                list.type = 'box';
                list.boxHTML = children[1].outerHTML;
              }
            }

            this.lists.push(list);
          }
        });

        // Initialize doughnut charts
        setTimeout(() => {
          // Initialize each block on page load (front end)
          document
            .querySelectorAll('.ecommerce-text-lists__charts-percent')
            .forEach((el) => new EcommerceTextListsChart(el));

          // Initialize the dynamic block preview (editor)
          if (window.acf) {
            window.acf.addAction('render_block_preview', ($block, attributes) => {
              $block
                .find('.ecommerce-text-lists__charts-percent')
                .each((i, el) => new EcommerceTextListsChart(el, attributes));
            });
          }
        });
      });
    },
  }));
});

class EcommerceTextListsChart {
  constructor(el) {
    this.el = el;
    this.canvas = el.querySelector('.ecommerce-text-lists__charts-percent-canvas');
    this.ctx = this.canvas.getContext('2d');
    this.percent = +this.canvas.dataset.percent.replace('%', '');
    this.data = [
      { label: '', value: this.percent },
      { label: '', value: 100 - this.percent },
    ];
    this.palette = ['rgb(38, 116, 224)', 'rgb(230, 230, 230)'];

    viewport.observe(this.el, () => {
      if (!this.chart) {
        this.chart = new Chart(this.ctx, this.getOptions());
      }
    });
  }

  getOptions() {
    return {
      type: 'doughnut',
      data: {
        labels: this.data.map((item) => item.label),
        datasets: [
          {
            data: this.data.map((item) => item.value),
            backgroundColor: this.palette,
            hoverBackgroundColor: this.palette,
          },
        ],
      },
      options: {
        datasets: {
          doughnut: {
            cutout: '56%',
            hoverBorderWidth: 0,
            hoverOffset: 0,
            offset: 0,
            borderRadius: 6,
          },
        },
        animation: {
          animateScale: true,
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    };
  }
}